import { Navigation } from "swiper";

window.onload = function () {

  /* show / hide main nav
  -------------------------------------------------- */

  const nav = document.querySelector('.js-nav');
  const btnnav = document.querySelector('.js-toggle-icon');
  const logo = document.querySelector('.logo');

 
  // Toggle menu to visible
  btnnav.addEventListener("click", () => {
    nav.classList.toggle('is-open');
  });

  // Toggle burger and close icon 
  btnnav.addEventListener("click", () => {
    btnnav.classList.toggle('icon-close');
    btnnav.classList.toggle('icon-menu');
  });
};

export default Navigation;
